import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/contractInvoicePartnerPerson'

function* fetchContractInvoicePartnerPersonsRefresh() {
  try {
    let fe = JSON.parse(localStorage.getItem('fetchContractInvoicePartnerPersons'))
    if (fe == null) {
      fe = { size: 10, index: 0, searchTerm: '%20', orderBy: '%20' }
    }
    const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
    yield put({ type: actions.LIST_CONTRACTINVOICEPARTNERPERSON, result })
  } catch (e) {
    console.error('fetchContractInvoicePartnerPersonsRefresh error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractInvoicePartnerPersons({ size, index, searchTerm, orderBy }) {
  try {
    if (!size && !index && !searchTerm && !orderBy) {
      const fe = JSON.parse(localStorage.getItem('fetchContractInvoicePartnerPersons'))
      if (fe != null) {
        size = fe.size || 10
        index = fe.index || 0
        searchTerm = fe.searchTerm || '%20'
        orderBy = fe.orderBy || '%20'
      } else {
        size = 10
        index = 0
        searchTerm = '%20'
        orderBy = '%20'
      }
    }
    localStorage.setItem(
      'fetchContractInvoicePartnerPersons',
      JSON.stringify({ size, index, searchTerm, orderBy }),
    )
    yield put({ type: actions.REQUESTING })
    const result = yield call(list, size, index, searchTerm, orderBy)
    yield put({ type: actions.LIST_CONTRACTINVOICEPARTNERPERSON, result })
  } catch (e) {
    console.error('fetchContractInvoicePartnerPersons error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractInvoicePartnerPersonEdit({ id }) {
  try {
    yield put({ type: actions.REQUESTING })
    const result = yield call(find, id)
    yield put({ type: actions.EDIT_CONTRACTINVOICEPARTNERPERSON, result })
  } catch (e) {
    console.error('fetchContractInvoicePartnerPersonEdit error', e)
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractInvoicePartnerPersonSave(values) {
  try {
    const result = yield call(save, values)
    if (result !== null) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    }
    yield put({ type: actions.SAVE_CONTRACTINVOICEPARTNERPERSON_RECIEVED, result })
    yield put({ type: actions.RE_FETCH_CONTRACTINVOICEPARTNERPERSONS })
  } catch (e) {
    console.error('fetchContractInvoicePartnerPersonSave error', e)
    notification.error({ message: 'Save failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

function* fetchContractInvoicePartnerPersonDelete(values) {
  try {
    const result = yield call(remove, values)
    if (result !== null) {
      notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
    }
    yield put({ type: actions.DELETE_CONTRACTINVOICEPARTNERPERSON_RECIEVED, result })
    yield put({ type: actions.RE_FETCH_CONTRACTINVOICEPARTNERPERSONS })
  } catch (e) {
    console.error('fetchContractInvoicePartnerPersonDelete error', e)
    notification.error({ message: 'Delete failed', description: e.message })
    yield put({ type: actions.RESPONSE_ERROR, message: e.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CONTRACTINVOICEPARTNERPERSONS, fetchContractInvoicePartnerPersons),
    takeEvery(actions.FETCH_CONTRACTINVOICEPARTNERPERSON, fetchContractInvoicePartnerPersonEdit),
    takeEvery(actions.SAVE_CONTRACTINVOICEPARTNERPERSON, fetchContractInvoicePartnerPersonSave),
    takeEvery(actions.DELETE_CONTRACTINVOICEPARTNERPERSON, fetchContractInvoicePartnerPersonDelete),
    takeEvery(actions.RE_FETCH_CONTRACTINVOICEPARTNERPERSONS, fetchContractInvoicePartnerPersonsRefresh),
  ])
}
